import { Box, Typography } from '@mui/material';

export function SamplingGoalWidget({ samplingActual = 0 }) {
  return (
    <Box
      data-testid="sampling-goals-widget"
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'end',
      }}
    >
      <Typography>
        {`Internally sampled acres for ${new Date().getFullYear()}: `}
        {Math.round(samplingActual).toLocaleString()}
      </Typography>
    </Box>
  );
}
